import React from "react";
import classNames from "classnames";
import BaseRow from "../BaseRow";

export default class ChannelsRow extends BaseRow {
	generateInfo() {
		let classes = this.props.classes;
		let text = this.props.text;
		return this.props.data.map((item, index) => {
			let minutes = "-";
			let type = null;
			if (!!item.mobile_new) {
				minutes = parseInt(item.mobile_new.calls);
				type = item.mobile_new.calls_type;
			}

			return (
				<div key={index} className={classes.cell}>
					<div className={classes.cellText}>
						<span className={classes.cellTextValue}>
							{type === 2 && <span>{minutes}</span>}
							{type === 1 && (
								<span
									className={classNames(
										classes.cellTextValueIconInfinity,
										"icon24",
										"icon-infinite"
									)}
								/>
							)}
							{!type && <span>-</span>}
						</span>
						<span className={classes.cellTextDimension}>{!!type && <span>{text.min}</span>}</span>
					</div>
				</div>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style}>
					<div className={classes.headerCellText}>{this.props.header}</div>
				</div>
				<div className={classes.cellsWrapper}>{this.generateInfo()}</div>
			</div>
		);
	}
}
